// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__2IByV","left":"style_left__JWQF+","copy":"style_copy__Jm4W3","right":"style_right__4pyMV"};